import { Component } from '@angular/core';
import { BaseFormTemplateDirective } from 'src/app/directives/base-form-template.directive';

@Component({
  selector: 'app-email-templates-form',
  templateUrl: './email-templates-form.component.html',
  styleUrls: ['./email-templates-form.component.sass']
})
export class EmailTemplatesFormComponent extends BaseFormTemplateDirective {
  override title = 'MENU.EMAIL-TEMPLATE'
  override form = {
    subject: null,
    html: null,
    text: null
  }
  path = 'city'
  states = []


  override handleItemEditSuccess(data: any) {
    super.handleItemEditSuccess(data)
    this.form = {
      html: data.TemplateContent.Html,
      subject: data.TemplateContent.Subject,
      text: data.TemplateContent.Text
    }
  }


  override getItemEdit() {
    this.editService = this.data.core.emailTemplateUnique(this.editId)
    super.getItemEdit()
  }


  override setSubmitMethods(): void {
    this.postService = this.data.core.wallCreate(this.formSanitized)
    this.putService = this.data.core.emailTemplateUpdate(this.editId, this.formSanitized)
  }
}


